<script lang="ts">
    export let padding: string = "2rem";
</script>

<div style="--padding: {padding}">
    <slot />
</div>

<style>
    div {
        background-color: rgba(255, 255, 255, 0.6);
        padding: var(--padding);
        border-radius: 15px;
        box-shadow: rgba(0, 0, 0, 0.2) 13px 13px 10px 3px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
